import { applyDrop } from '../../domain/dnd/dispatch';
import type { DragData, DropData } from '../../domain/dnd/types';
import { isDropSlotEnabled } from '../../domain/dnd/rules';
import { getEditorStore, getEditorStoreState } from '../../domain/store';
import { suppressPaletteClickAfterDragDrop } from './palette-activation-guard';

export function commitEditorDrop(active: DragData, over: DropData): void {
  const sections = getEditorStoreState().document.sections;
  if (!isDropSlotEnabled(sections, over, active)) {
    return;
  }
  if (active.kind.startsWith('palette-')) {
    suppressPaletteClickAfterDragDrop();
  }
  const store = getEditorStore();
  applyDrop(active, over, {
    getDocument: () => store.document,
    insertBlock: store.insertBlock,
    moveBlock: store.moveBlock,
    insertRowWithBlock: store.insertRowWithBlock,
    moveBlockToNewRow: store.moveBlockToNewRow,
    insertRow: store.insertRow,
    insertGroup: store.insertGroup,
    insertSnippet: store.insertSnippet,
    moveTopLevelSection: store.moveTopLevelSection,
    moveContiguousTopLevelRows: store.moveContiguousTopLevelRows,
    moveContiguousGroupRows: store.moveContiguousGroupRows,
    moveRowInGroup: store.moveRowInGroup,
    moveRowBetweenParents: store.moveRowBetweenParents,
  });
}
